<h1>Reset E-Mail versandt</h1>
<p>Die E-Mail um dein Passwort zurückzusetzen wurde erfolgreich versandt und sollte jede Minute bei dir eintreffen.</p>
<p>Bitte öffne den darin enthaltenen Reset-Link um ein neues Passwort zu vergeben.</p>
